module.exports = __webpack_public_path__ + "img/tblside-logomark-color.0566c1aa.png";